import React from 'react';
import { FadeIn, Section } from './Shared';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import BoltIcon from '@mui/icons-material/Bolt';
import SoupKitchenIcon from '@mui/icons-material/SoupKitchen';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import TableChartIcon from '@mui/icons-material/TableChart';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
export function WhatYouGet() {
  const features = [{
    icon: <RestaurantMenuIcon fontSize="large" data-id="element-120" />,
    title: '21 Chef-Vetted Recipes',
    desc: 'From Butter-Fried Halloumi to Perfect Pizza Perfection.'
  }, {
    icon: <BoltIcon fontSize="large" data-id="element-121" />,
    title: "The '5-Gram Carb' Shortlist",
    desc: '5 recipes with virtually zero carbs for your strictest days.'
  }, {
    icon: <SoupKitchenIcon fontSize="large" data-id="element-122" />,
    title: 'One-Pot Wonders',
    desc: 'Minimal cleanup with dishes like the Chicken & Bacon One-Pot.'
  }, {
    icon: <FitnessCenterIcon fontSize="large" data-id="element-123" />,
    title: 'High-Protein Power Houses',
    desc: 'Recipes with up to 57g of protein to keep you satiated.'
  }, {
    icon: <SwapHorizIcon fontSize="large" data-id="element-124" />,
    title: 'The Substitution Cheat Sheet',
    desc: 'How to swap pasta, rice, and breadcrumbs like a pro.'
  }, {
    icon: <TableChartIcon fontSize="large" data-id="element-125" />,
    title: 'Quick Reference Macro Table',
    desc: 'Every calorie and carb count laid out for at-a-glance planning.'
  }];
  return <Section className="bg-white" data-id="element-126">
      <div className="text-center mb-16" data-id="element-127">
        <FadeIn data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-129">
            What's Inside The Guide
          </h2>
          <p className="text-lg text-charcoal-light max-w-2xl mx-auto" data-id="element-130">
            Everything you need to succeed, perfectly organized for quick
            access.
          </p>
        </FadeIn>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-131">
        {features.map((feature, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-132">
            <div className="bg-cream p-8 rounded-2xl h-full border border-cream-dark hover:shadow-soft transition-shadow duration-300" data-id="element-133">
              <div className="w-14 h-14 bg-sage/10 text-sage rounded-xl flex items-center justify-center mb-6" data-id="element-134">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 font-sans" data-id="element-135">
                {feature.title}
              </h3>
              <p className="text-charcoal-light leading-relaxed" data-id="element-136">
                {feature.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}
export function WhoItsFor() {
  const forWho = ['Women 45+ who want to lose weight without feeling hungry all day.', "Busy professionals or moms who need 'weeknight-ready' 15-minute meals.", "Beginners who want to start Keto correctly without the 'learning curve' frustration.", 'Anyone struggling with inflammation, bloating, and stubborn mid-section weight.'];
  const notForWho = ["People looking for a 'high-carb' lifestyle or complex gourmet cooking.", 'Those unwilling to swap traditional bread and pasta for healthier, low-carb alternatives.', 'Anyone looking for medical treatment for chronic conditions (consult your doctor first).'];
  return <Section data-id="element-137">
      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-138">
        <FadeIn data-id="element-139">
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-soft h-full border-t-4 border-sage" data-id="element-140">
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-141">
              <span className="text-sage" data-id="element-142">Who This Is For</span>
            </h3>
            <ul className="space-y-6" data-id="element-143">
              {forWho.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-144">
                  <CheckCircleIcon className="text-sage mt-1 flex-shrink-0" data-id="element-145" />
                  <span className="text-lg text-charcoal" data-id="element-146">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-147">
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-soft h-full border-t-4 border-terracotta" data-id="element-148">
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-149">
              <span className="text-terracotta" data-id="element-150">Who This Is NOT For</span>
            </h3>
            <ul className="space-y-6" data-id="element-151">
              {notForWho.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-152">
                  <CancelIcon className="text-terracotta mt-1 flex-shrink-0" data-id="element-153" />
                  <span className="text-lg text-charcoal" data-id="element-154">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </Section>;
}